import { render, staticRenderFns } from "./checklist-album-list-item.vue?vue&type=template&id=042ab970"
import script from "./checklist-album-list-item.vue?vue&type=script&lang=js"
export * from "./checklist-album-list-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports